export default __webpack_public_path__ + "static/media/info_black_24dp.db4875de.svg";